// import

import {styled} from 'goober';
import type {ComponentProps} from 'react';
import {useForm} from 'react-hook-form';

import {SignupForm} from 'modules/SignupForm';
import {Type, linesToBreaks} from 'modules/Type';

import {useSettings} from './useSettings';

// types

type Props = ComponentProps<typeof Signup>;

// component

export function AppFooterSignup(props: Props) {
  const {...rest} = props;
  const {
    nav: {footerCta: {headline, buttonText, blurbMark}},
  } = useSettings();
  const form = useForm();

  return (
    <Signup {...rest}>
      <h3
        className="copy"
        dangerouslySetInnerHTML={{__html: linesToBreaks(headline)}}
      />

      <SignupForm
        buttonClass="button yellow"
        buttonText={buttonText}
        className="form"
        form={form}
      >
        <div className="blurb" dangerouslySetInnerHTML={{__html: blurbMark}} />
      </SignupForm>
    </Signup>
  );
}

// styles

const Signup = styled(Type)`
  display: grid;
  column-gap: 3rem;
  row-gap: 0.5rem;
  font-size: 1rem;
  line-height: 1.15rem;
  grid: [row1-start] "copy form" [row1-end] / max-content auto;

  & .copy {
    grid-area: copy;
    font-family: var(--font-head);
    letter-spacing: 0;
    font-size: 1.75rem;
    line-height: 2.25rem;
    margin: 0;
    font-weight: 400;
    word-break: none;
    word-wrap: none;
  }

  & .form {
    grid-area: form;
    display: grid;
    column-gap: 0.5rem;
    row-gap: 0.5rem;
    align-content: end;
    grid:
      [row1-start] "copy copy" [row1-end]
      [row2-start] "input button" [row2-end]
      / 70% auto;

    @media (min-width: 27em) and (max-width: 35.99875em) {
      grid:
        [row-start] "copy" [row-end]
        [row-start] "input button" [row-end];
    }

    @media (max-width: 26.99875em) {
      grid:
        [row1-start] "copy" [row1-end]
        [row2-start] "input" [row2-end]
        [row3-start] "button" [row3-end];
    }
  }

  & .blurb {
    grid-area: copy;
  }

  & .error {
    color: var(--red-30);
  }

  & .success {
    color: var(--yellow);
  }

  & input {
    grid-area: input;
  }

  & button {
    grid-area: button;
    height: 2.5rem;
    line-height: 2.5rem;
    padding: 0 1rem;
  }

  @media (max-width: 53.99875em) {
    grid:
      [row1-start] "copy" [row1-end]
      [row2-start] "form" [row2-end];
  }
`;
